// Initial State
const initialState = {
  order: {},
  ordersHistory: [],
  pagination: 0,
  pdf: null,
}

// Action constants
const GET_ORDER = 'GET_ORDER'
const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS'
const GET_ORDER_FAILURE = 'GET_ORDER_FAILURE'

const GET_ORDERS_HISTORY = 'GET_ORDERS_HISTORY'
const GET_ORDERS_HISTORY_SUCCESS = 'GET_ORDERS_HISTORY_SUCCESS'
const GET_ORDERS_HISTORY_FAILURE = 'GET_ORDERS_HISTORY_FAILURE'

const PATIENT_ORDER_UPDATE = 'PATIENT_ORDER_UPDATE'
const PATIENT_ORDER_UPDATE_SUCCESS = 'PATIENT_ORDER_UPDATE_SUCCESS'
const PATIENT_ORDER_UPDATE_FAILURE = 'PATIENT_ORDER_UPDATE_FAILURE'

const PATIENT_REMEDY_UPDATE = 'PATIENT_REMEDY_UPDATE'
const PATIENT_REMEDY_UPDATE_SUCCESS = 'PATIENT_REMEDY_UPDATE_SUCCESS'
const PATIENT_REMEDY_UPDATE_FAILURE = 'PATIENT_REMEDY_UPDATE_FAILURE'

const ORDER_SUPPORT_NOTE_UPDATE = 'ORDER_SUPPORT_NOTE_UPDATE'
const ORDER_SUPPORT_NOTE_UPDATE_SUCCESS = 'ORDER_SUPPORT_NOTE_UPDATE_SUCCESS'
const ORDER_SUPPORT_NOTE_UPDATE_FAILURE = 'ORDER_SUPPORT_NOTE_UPDATE_FAILURE'

const GENERATE_NOMINATION_FORM = 'GENERATE_NOMINATION_FORM'
const GENERATE_NOMINATION_FORM_SUCCESS = 'GENERATE_NOMINATION_FORM_SUCCESS'
const GENERATE_NOMINATION_FORM_FAILURE = 'GENERATE_NOMINATION_FORM_FAILURE'

// Action creators
export const getOrder = orderID => {  
  return {
    types: [GET_ORDER, GET_ORDER_SUCCESS, GET_ORDER_FAILURE],
    payload: {
      request: {
        url: `/orders/${orderID}`,
        method: 'GET',
      }
    }
  }
}

export const getOrdersHistory = (patientId, page, limit) => {
  // TODO: Pagination
  return {
    types: [GET_ORDERS_HISTORY, GET_ORDERS_HISTORY_SUCCESS, GET_ORDERS_HISTORY_FAILURE],
    payload: {
      request: {
        url: `/orders?patient_id=${patientId}&page=${page}&limit=${limit}`,
        method: 'GET',
      },
    },
  }
}

export const updateOrderState = ({ patientId, orderId, processState }) => ({
  types: [PATIENT_ORDER_UPDATE, PATIENT_ORDER_UPDATE_SUCCESS, PATIENT_ORDER_UPDATE_FAILURE],
  payload: {
    request: {
      url: `/patient/${patientId}/orders/${orderId}`,
      method: 'PUT',
      data: { processState, orderId, patientId },
    },
  },
})

export const toggleRemedyState = ({ patientId, orderId, remedyId }) => ({
  types: [PATIENT_REMEDY_UPDATE, PATIENT_REMEDY_UPDATE_SUCCESS, PATIENT_REMEDY_UPDATE_FAILURE],
  payload: {
    request: {
      url: `/patient/${patientId}/orders/${orderId}/remedy/${remedyId}`,
      method: 'PUT',
      data: { remedyId, orderId, patientId },
    },
  },
})

export const updateOrderSupportNote = ({ patientId, orderId, text }) => ({
  types: [ORDER_SUPPORT_NOTE_UPDATE, ORDER_SUPPORT_NOTE_UPDATE_SUCCESS, ORDER_SUPPORT_NOTE_UPDATE_FAILURE],
  payload: {
    request: {
      url: `/patient/${patientId}/orders/${orderId}`,
      method: 'PUT',
      data: { orderId, patientId, text },
    },
  },
})

export const generateNominationForm = (pharmacyId, patientId, orderId, data) => ({
  types: [GENERATE_NOMINATION_FORM, GENERATE_NOMINATION_FORM_SUCCESS, GENERATE_NOMINATION_FORM_FAILURE],
  payload: {
    request: {
      url: `pharmacies/${pharmacyId}/patients/${patientId}/repeats/${orderId}/nomination`,
      method: 'POST',
      data
    }
  }
})

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDER:
      return {
        ...state
      }
    case GET_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload.data.data
      }
    case GET_ORDER_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case GET_ORDERS_HISTORY:
      return {
        ...state,
      }
      case GET_ORDERS_HISTORY_SUCCESS:        
        return {
          ...state,
          pagination: action.payload?.data?.pagination,
          ordersHistory: action.payload.data.data,
      }
    case GET_ORDERS_HISTORY_FAILURE:
      return {
        ...state,
      }
    case PATIENT_ORDER_UPDATE:
      // overwrite order state (new/toApprove/toPrepare)
      return {
        ...state,
        order: {
          ...state.order,
          processState: action.payload.request.data.processState,
        },
        ordersHistory: state.ordersHistory.map(item => {
          if (item.id === action.payload.request.data.orderId) {
            return {
              ...item,
              processState: action.payload.request.data.processState,
            }
          }

          return item
        }),
      }
    case PATIENT_ORDER_UPDATE_SUCCESS:
      return {
        ...state,
      }
    case PATIENT_ORDER_UPDATE_FAILURE:
      return {
        ...state,
      }
    case PATIENT_REMEDY_UPDATE:
      // overwrite remedy state (checked/unchecked) for specific order
      return {
        ...state,
        order: {
          ...state.order,
          remedies: state.order.remedies.map(remedy =>
            remedy.id === action.payload.request.data.remedyId
              ? { ...remedy, checked: !remedy.checked }
              : { ...remedy },
          ),
        },
        ordersHistory: state.ordersHistory.map(item => {
          if (item.id === action.payload.request.data.orderId) {
            return {
              ...item,
              remedies: item.remedies.map(remedy =>
                remedy.id === action.payload.request.data.remedyId
                  ? { ...remedy, checked: !remedy.checked }
                  : { ...remedy },
              ),
            }
          }

          return item
        }),
      }
    case PATIENT_REMEDY_UPDATE_SUCCESS:
      return {
        ...state,
      }
    case PATIENT_REMEDY_UPDATE_FAILURE:
      return {
        ...state,
      }
    case GENERATE_NOMINATION_FORM:
      return {
        ...state,
      }
    case GENERATE_NOMINATION_FORM_SUCCESS:
      return {
        ...state,
        pdf: action.payload.data.data[0].pdf_url
      }
    case GENERATE_NOMINATION_FORM_FAILURE:
      return {
        ...state,
      }

    default:
      return state
  }
}

export default orderReducer;
